import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
import dayjs from 'dayjs';
import { mapActions, mapGetters } from 'vuex'; // import localeMixin from '@/locales/mixin.js'

export default {
  // mixins: [
  //   localeMixin
  // ],
  data: function data() {
    return {
      timeInterval: null,
      time: dayjs().format('HH:mm:ss'),
      // 快速选择用户
      dialogVisible: false,
      // 表单
      formLogin: {
        username: '',
        password: '',
        captcha: ''
      },
      captchaNC: null,
      // 表单校验
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }, {
          min: 6,
          max: 20,
          message: '请输入6-20个字符',
          trigger: 'blur'
        }, {
          pattern: /^(\w){6,20}$/,
          message: '请输入6-20个字母、数字或下划线',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        captcha: [{
          required: true,
          message: '请滑动验证码到最右边',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.set(this.themeActiveSetting.name);
    this.initCapcha();
    this.timeInterval = setInterval(function () {
      _this2.refreshTime();
    }, 1000); // this.showNotice()
  },
  computed: _objectSpread({}, mapGetters('u8sdk', {
    themeActiveSetting: 'theme/activeSetting'
  })),
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('u8sdk/account', ['login'])), mapActions('u8sdk/theme', ['set'])), {}, {
    showNotice: function showNotice() {
      var show = util.cookies.get('needShowNotice');

      if (!show || show == undefined || show != 1) {
        util.cookies.set('needShowNotice', '1');
        this.$alert('欢迎来到U8SDK演示后台！您可以使用任意符合条件的用户名和密码登陆演示后台。但是为了保护您的隐私安全，避免信息泄露，请不要使用您的常用用户名和密码。同时，为了您下次可以顺利登陆，请记录一下您的用户名和密码');
      }
    },
    initCapcha: function initCapcha() {
      var _this = this;

      var appkey = process.env.VUE_APP_CAPCHA_APPKEY;
      var scene = process.env.VUE_APP_CAPCHA_SCENE;
      var nc_token = [appkey, new Date().getTime(), Math.random()].join(':');
      var NC_Opt = {
        renderTo: "#captcha",
        appkey: appkey,
        scene: scene,
        token: nc_token,
        customWidth: 236,
        trans: {
          "key1": "code0"
        },
        elementID: ["u8sdkAdmin"],
        is_Opt: 0,
        language: "cn",
        isEnabled: true,
        timeout: 3000,
        times: 5,
        apimap: {// 'analyze': '//a.com/nocaptcha/analyze.jsonp',
          // 'get_captcha': '//b.com/get_captcha/ver3',
          // 'get_captcha': '//pin3.aliyun.com/get_captcha/ver3'
          // 'get_img': '//c.com/get_img',
          // 'checkcode': '//d.com/captcha/checkcode.jsonp',
          // 'umid_Url': '//e.com/security/umscript/3.2.1/um.js',
          // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
          // 'umid_serUrl': 'https://g.com/service/um.json'
        },
        callback: function callback(data) {
          var captchaInfo = {
            'sessionId': data.csessionid,
            'sig': data.sig,
            'token': nc_token,
            'scene': scene
          };
          _this.formLogin.captcha = JSON.stringify(captchaInfo);
        }
      };
      this.captchaNC = new noCaptcha(NC_Opt);
      this.captchaNC.upLang('cn', {
        _startTEXT: "请按住滑块，拖动到最右边",
        _yesTEXT: "验证通过",
        _error300: "哎呀，出错了，点击<a href=\"javascript:__nc.reset()\">刷新</a>再来一次",
        _errorNetwork: "网络不给力，请<a href=\"javascript:__nc.reset()\">点击刷新</a>"
      });
    },
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    },

    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit: function submit() {
      var _this3 = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          // 登录
          // 注意 这里的演示没有传验证码
          // 具体需要传递的数据请自行修改代码
          _this3.login({
            username: _this3.formLogin.username,
            password: _this3.formLogin.password,
            captcha: _this3.formLogin.captcha
          }).then(function () {
            // 重定向对象不存在则返回顶层路径
            _this3.$router.replace(_this3.$route.query.redirect || '/');
          }).catch(function () {
            if (_this3.captchaNC) {
              _this3.formLogin.captcha = '';

              _this3.captchaNC.reload();
            }
          });
        } else {
          // 登录表单校验失败
          _this3.$message.error('表单校验失败，请检查');

          if (_this3.captchaNC) {
            _this3.formLogin.captcha = '';

            _this3.captchaNC.reload();
          }
        }
      });
    }
  })
};